import React, { Component } from 'react';
import style from '../share/pageUpdate.module.css';
import TextBoxWithLabel from '../../components/TextBoxWithLabel.js';
import TemplateV2 from '../../components/TemplateV2';
import DefaultBtn from '../../components/DefaultBtn.js';
import CheckBoxWithLabel from '../../components/CheckBoxWithLabel.js';
//import axios from 'axios'
import BackDropLoading from '../../components/BackDropLoading.js';
import * as utils from '../../Utils.js';

class AdyenSettingUpdate extends Component {
    constructor(props) {
        //alert("HotelCrate");
        super(props);
        this.state = {
            dataObject: null,
            validateObject: null,
            loading: true,
            showSuccess: false
            //companyId: this.props.match.params.id
        };

    }


    componentDidMount() {
        this.props.appState.checkUser(this.props.appState);
        this.callGetData();

        let userObject = this.props.appState.userObject;
        let isSysAdmin = utils.IsInRole(userObject, "SystemAdmin");
        //let isHopAdmin = utils.IsInRole(userObject, "HopinnAdmin");
        //let isHopStaff = utils.IsInRole(userObject, "HopinnStaff");
        if(isSysAdmin !== true){
            this.props.appState.logout();
        }
    }

    callGetData() {
        let url = process.env.REACT_APP_API_END_POINT + "/api/BackOffice/GetAdyenSettingData";
        // let data = {
        //     Id: this.props.id
        // };
        //let appState = this.props.appState;

        let data = {};


        let appState = this.props.appState;
        let token = appState.userObject.Token;

        utils.callPost(url, token, data, this.callGetDataCallBack);

        this.setState({
            loading: true,
            showSuccess: false
        })







    }
    callGetDataCallBack = (data) => {
        //console.log("debug");
        //console.log(data);

        this.setState({
            dataObject: { ...data.Data.dataObject },
            validateObject: { ...data.Data.validateObject },
            loading: false
        })
    }
    callSetData() {
        let url = process.env.REACT_APP_API_END_POINT + "/api/BackOffice/UpdateAdyenSettingData";
        let data = { ...this.state.dataObject };
        let appState = this.props.appState;
        let token = appState.userObject.Token;

        utils.callPost(url, token, data, this.callSetDataCallBack);



        // axios
        //     .post(url, data, {
        //         headers: {
        //             'Authorization': appState.userObject.Token
        //         }
        //     })
        //     .then(response => {
        //         this.callSetDataCallBack(response.data);
        //     })
        //     .catch(err => {
        //         console.error(err)
        //     })

        this.setState({
            loading: true
        })
    }
    callSetDataCallBack = (data) => {
        //console.log(data);

        if (data.Success === true) {
            //alert("success");
            this.setState({
                loading: false,
                showSuccess: true,
                validateObject: { ...data.Data.validateObject }
            })
            //this.props.onClose();
        }
        else {
            this.setState({
                loading: false,
                dataObject: { ...data.Data.dataObject },
                validateObject: { ...data.Data.validateObject }
            })
        }
    }









    handleChange = (e) => {
        //console.log(e);
        let dataObject = this.state.dataObject;
        if (e.target.name === "adyen_url") dataObject.adyen_url = e.target.value;
        if (e.target.name === "adyen_apikey") dataObject.adyen_apikey = e.target.value;
        if (e.target.name === "adyen_countrycode") dataObject.adyen_countrycode = e.target.value;
        if (e.target.name === "adyen_shopperlocale") dataObject.adyen_shopperlocale = e.target.value;
        if (e.target.name === "adyen_merchantaccount") dataObject.adyen_merchantaccount = e.target.value;

        if (e.target.name === "webhook_user") dataObject.webhook_user = e.target.value;
        if (e.target.name === "webhook_password") dataObject.webhook_password = e.target.value;
        if (e.target.name === "timeLimit") dataObject.timeLimit = e.target.value;


        if (e.target.name === "adyen_url_uat") dataObject.adyen_url_uat = e.target.value;
        if (e.target.name === "adyen_apikey_uat") dataObject.adyen_apikey_uat = e.target.value;
        if (e.target.name === "adyen_merchantaccount_uat") dataObject.adyen_merchantaccount_uat = e.target.value;
        if (e.target.name === "enable_prod") dataObject.enable_prod = e.target.checked;
        if (e.target.name === "enable_onebath") dataObject.enable_onebath = e.target.checked;
        if (e.target.name === "enable_creditcard") dataObject.enable_creditcard = e.target.checked;







        //if (e.target.name === "email_ssl") dataObject.email_ssl = e.target.checked;





        this.setState({
            showSuccess: false,
            dataObject: { ...dataObject },
        })
    }
    handleClick = (e) => {
        //alert("Update");
        //console.log(e);
        if (e.target.name === "Update") {
            this.callSetData();
        }
        // if (e.target.name === "Delete") {
        //     this.callDeleteData();
        // }
        // if(e.target.name === "Reissue"){
        //     this.callReissue();
        // }
        if (e.target.name === "Cancel") {
            this.callGetData();
        }




        // if(method === "Update"){
        //     alert("Update");
        // }
    }


    render() {
        let result = [];
        let dataObject = this.state.dataObject;
        let validateObject = this.state.validateObject;

        if (dataObject != null) {
            //let rowNameInput = this.renderNameInput(dataObject, validateObject);
            //alert(this.props.Id);
            result = (
                <div className={style.createArea}>
                    <BackDropLoading show={this.state.loading} />


                    <div className={style.navBar}>
                        <div className={style.nav}>Home</div>
                        <i className="fas fa-chevron-right"></i>
                        <div className={style.navSelect}>Adyen Setting</div>

                    </div>


                    {(this.state.showSuccess === true) &&
                        <div className={style.message_bar}>
                            Your data was save.
                        </div>
                    }




                    <div className={style.contentBox}>

                        {this.props.method === "Create" &&
                            <div className={style.contentTitle}>Create Affiliated Company</div>
                        }
                        {this.props.method === "Edit" &&
                            <div className={style.contentTitle}>Edit Adyen Setting</div>
                        }
                        {this.props.method === "Delete" &&
                            <div className={style.contentTitle}>Delete Affiliated Company</div>
                        }






                        <div className={style.line}></div>



                        {/* <div className={style.sectionInput800}>
                            <CheckBoxWithLabel name="email_ssl" label="email_ssl" value={dataObject.email_ssl } errorMessage="" onChange={this.handleChange} />
                        </div> */}




                        <div className={style.sectionInput800}>
                            <CheckBoxWithLabel name="enable_prod" label="enable_prod" value={dataObject.enable_prod} errorMessage="" onChange={this.handleChange} />
                        </div>

                        <div className={style.sectionInput800}>
                            <CheckBoxWithLabel name="enable_creditcard" label="enable_creditcard" value={dataObject.enable_creditcard} errorMessage="" onChange={this.handleChange} />
                        </div>

                        <div className={style.sectionInput800}>
                            <CheckBoxWithLabel name="enable_onebath" label="enable_onebath" value={dataObject.enable_onebath} errorMessage="" onChange={this.handleChange} />
                        </div>


                        <div className={style.sectionInput800}>
                            <TextBoxWithLabel name="adyen_url" label="adyen_url" value={dataObject.adyen_url} errorMessage={validateObject.adyen_url} onChange={this.handleChange} />
                        </div>
                        <div className={style.sectionInput800}>
                            <TextBoxWithLabel name="adyen_merchantaccount" label="adyen_merchantaccount" value={dataObject.adyen_merchantaccount} errorMessage={validateObject.adyen_merchantaccount} onChange={this.handleChange} />
                        </div>
                        <div className={style.sectionInput800}>
                            <TextBoxWithLabel name="adyen_apikey" label="adyen_apikey" value={dataObject.adyen_apikey} errorMessage={validateObject.adyen_apikey} onChange={this.handleChange} />
                        </div>
                        <div className={style.sectionInput800}>
                            <TextBoxWithLabel name="adyen_countrycode" label="adyen_countrycode" value={dataObject.adyen_countrycode} errorMessage={validateObject.adyen_countrycode} onChange={this.handleChange} />
                        </div>
                        <div className={style.sectionInput800}>
                            <TextBoxWithLabel name="adyen_shopperlocale" label="adyen_shopperlocale" value={dataObject.adyen_shopperlocale} errorMessage={validateObject.adyen_shopperlocale} onChange={this.handleChange} />
                        </div>

                        <div className={style.sectionInput800}>
                            <TextBoxWithLabel name="webhook_user" label="webhook_user" value={dataObject.webhook_user} errorMessage={validateObject.webhook_user} onChange={this.handleChange} />
                        </div>
                        <div className={style.sectionInput800}>
                            <TextBoxWithLabel name="webhook_password" label="webhook_password" value={dataObject.webhook_password} errorMessage={validateObject.webhook_password} onChange={this.handleChange} />
                        </div>



                        <div className={style.sectionInput800}>
                            <TextBoxWithLabel name="adyen_url_uat" label="adyen_url_uat" value={dataObject.adyen_url_uat} errorMessage={validateObject.adyen_url_uat} onChange={this.handleChange} />
                        </div>
                        <div className={style.sectionInput800}>
                            <TextBoxWithLabel name="adyen_merchantaccount_uat" label="adyen_merchantaccount_uat" value={dataObject.adyen_merchantaccount_uat} errorMessage={validateObject.adyen_merchantaccount_uat} onChange={this.handleChange} />
                        </div>
                        <div className={style.sectionInput800}>
                            <TextBoxWithLabel name="adyen_apikey_uat" label="adyen_apikey_uat" value={dataObject.adyen_apikey_uat} errorMessage={validateObject.adyen_apikey_uat} onChange={this.handleChange} />
                        </div>


                        <div className={style.sectionInput800}>
                            <TextBoxWithLabel name="timeLimit" label="timeLimit(minite)" value={dataObject.timeLimit} errorMessage={validateObject.timeLimit} onChange={this.handleChange} />
                        </div>



                        <div className={style.btnRow}>
                            <div className={style.btnRowCenter}>


                                {this.props.method === "Create" &&
                                    <div className={style.primaryBoxBtn}>
                                        <DefaultBtn label="Update" onClick={this.handleClick} name="Update" type="primary" />
                                    </div>
                                }
                                {this.props.method === "Edit" &&
                                    <div className={style.primaryBoxBtn}>
                                        <DefaultBtn label="Update" onClick={this.handleClick} name="Update" type="primary" />
                                    </div>
                                }
                                {this.props.method === "Delete" &&
                                    <div className={style.primaryBoxBtn}>
                                        <DefaultBtn label="Delete" onClick={this.handleClick} name="Delete" type="danger" />
                                    </div>
                                }
                                <div className={style.primaryBoxBtn}>
                                    <DefaultBtn label="Cancel" onClick={this.handleClick} name="Cancel" type="default" />
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            );
        }
        return (
            <TemplateV2 appState={this.props.appState} page={"adyensetting"}>
                {result}
            </TemplateV2>
        );
    }
}
export default AdyenSettingUpdate;